import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TransitGuaranteeLogItem} from '@portbase/bezoekschip-service-typescriptmodels';
import {VisitContext} from "../../../visit-details/visit-context";
import {ComparatorChain} from "../../../common/comparator-chain";
import {sendQuery} from "../../../common/utils";

@Component({
    selector: 'app-transit-guarantee-history',
    templateUrl: './transit-guarantee-history.component.html',
    styleUrls: ['./transit-guarantee-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransitGuaranteeHistoryComponent implements OnInit {

  context = VisitContext;
  items: TransitGuaranteeLogItem[] = [];
  reverseOrder = true;
  @Input() id: string;

  private logComparator = new ComparatorChain("timestamp").compare;

  ngOnInit(): void {
    sendQuery("com.portbase.bezoekschip.common.api.history.GetTransitGuaranteeLog", {id: this.id},
      {showSpinner: true, caching: false})
      .subscribe((items: TransitGuaranteeLogItem[]) => this.items = items.sort(this.logComparator));
  }

  cast = (item: TransitGuaranteeLogItem): TransitGuaranteeLogItem => item;

  toggleOrder() {
    this.reverseOrder = !this.reverseOrder;
  }
}
